$(document).ready(function() {
	'use strict';
	initAddressAutocomplete();


	$('[data-confirm]').click(function (event) {
		if (confirm($(this).data('confirm'))) {
			return true;
		}

		event.preventDefault();

		return false;
	});

	$('#menu-control').click(function() {
		$('#menu').toggleClass('active');

		return false;
	});

	$('#menu a').click(function() {
		$(this).parents('#menu').removeClass('active');
	});

	// FAQ accordion - keep at most one answer open. Runs before the browser toggles the clicked
	// item, so closing the already open one still works. Redundant where <details name> is
	// supported natively, but harmless there and the only behaviour older browsers get.
	$('#faqList > details > summary').click(function() {
		$(this).parent().siblings('details[open]').removeAttr('open');
	});

	// Required fields dialog
	const $dialog = $('#customerProfileIncompleteDialog');
	if ($dialog.length) {
		$dialog[0].showModal();
	}

	// Upgrades a link into a native <dialog> named by it (the BankID bank chooser). Every trigger is a real
	// link to our own initiate action, so this only ever ADDS the chooser: without this script the same click
	// still starts a verification and lands in BankID's own multi-bank chooser instead. That is deliberate -
	// the alternative to a pre-selected bank has to work everywhere, not only where JavaScript ran.
	$(document).on('click', '[data-dialog-open]', function (event) {
		const dialog = document.getElementById($(this).data('dialog-open'));

		if (dialog && typeof dialog.showModal === 'function') {
			event.preventDefault();
			dialog.showModal();
		}
	});
});


// Bot-protection cookie (`__Host-post-protection`) lives ~25 h and is refreshed on every
// GET. The page carries a `<meta http-equiv="refresh">` that reloads it ~1 h before the
// cookie expires, but Safari freezes that timer while the tab sits in the back/forward
// cache, so a tab resumed days later submits an expired cookie and gets a 403. Backstop:
// when the page becomes visible again (bfcache restore or app foreground), reload it if the
// refresh deadline has already passed so the GET re-issues the cookie.
(function () {
	'use strict';

	const meta = document.querySelector('meta[http-equiv="refresh" i]');
	if (meta === null) {
		return;
	}

	const refreshSeconds = parseInt(meta.getAttribute('content'), 10);
	if (isNaN(refreshSeconds) || refreshSeconds <= 0) {
		return;
	}

	// Absolute wall-clock deadline captured at load (+ a short grace so the browser's native
	// meta refresh acts first). The JS heap survives a bfcache restore, so on resume we compare
	// against real elapsed time instead of the frozen meta-refresh timer.
	const reloadAfter = Date.now() + (refreshSeconds + 10) * 1000;

	const reloadIfStale = function () {
		if (Date.now() >= reloadAfter) {
			window.location.reload();
		}
	};

	window.addEventListener('pageshow', function (event) {
		if (event.persisted) {
			reloadIfStale();
		}
	});

	document.addEventListener('visibilitychange', function () {
		if (document.visibilityState === 'visible') {
			reloadIfStale();
		}
	});
})();
